import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Input, { INPUT_TYPES } from '../Input/Input';
import './fancy_toggle_small.scss';

export default  class FancyToggleSmall extends Component {
  static propTypes = {
    className: PropTypes.string,
    onText: PropTypes.string,
    onColorClass: PropTypes.string.isRequired,
    offColorClass: PropTypes.string.isRequired,
    offText: PropTypes.string,
    toggleWidthClassName: PropTypes.string,
    toggleLabelClassName: PropTypes.string,
  };

  static defaultProps = {
    onText: 'ON',
    offText: 'OFF',
    onColorClass: 'green',
    offColorClass: 'darkGrey',
  };

  render() {
    const currentColor = this.props.checked
      ? this.props.onColorClass
      : this.props.offColorClass;

    return (
      <Input
        {...this.props}
        className={cx(
          'fancy_toggle_small justify-between',
          this.props.className,
          { checked: this.props.checked }
        )}
        inputClassName={cx(
          'shadow z-10 absolute appearance-none opacity-0 m-0 cursor-pointer w-full',
          this.props.inputClassName
        )}
        type={INPUT_TYPES.CHECKBOX}
        inputWrapperClassName={this.props.toggleWidthClassName}
        labelClassName={this.props.toggleLabelClassName}
        foreignComponent={
          <Fragment>
            <div
              className={`fancy_toggle_small__text absolute w-full h-full t-50 text-xxs text-${currentColor} font-bold`}>
              {this.props.checked ? this.props.onText : this.props.offText}
            </div>
            <div
              className={`fancy_toggle_small__knob absolute rounded-full t-50 bg-${currentColor}`}
            />
          </Fragment>
        }
      />
    );
  }
}
